import React, { Component } from "react";
import { connect } from "react-redux";
import { postDataAction, editDataAction } from "../config/redux/action";
import { HeaderCompReport } from "./Report/HeaderCompReport";
import { Form } from "reactstrap";
import { Laba } from "./Report/Laba";
import { Neraca } from "./Report/Neraca";
import { Arus } from "./Report/Arus";
import { Lpe } from "./Report/Lpe";
import Dokumen from "./Report/Dokumen";
import DokumenReadonly from "./Report/DokumenReadonly";
import { MenuMonth } from "../component/Utils";
import { MenuTopReport } from "./Report/MenuTopReport";
import LoadingTop from "../component/LoadingTop";

class Report extends Component {
  constructor() {
    super();
    this.state = {
      isLoadingButton: false,
    };
  }

  postData = (dataInput) => {
    const { pathAPI, menu, main } = this.props;

    this.setState({
      isLoadingButton: true,
    });

    const newDataInput = {
      ...dataInput,
      year: main.yearFilter,
      month: main.monFilter,
    };

    if (this.props.dataReport.content[0]) {
      const editDataInput = {
        ...newDataInput,
        id: this.props.dataReport ? this.props.dataReport.content[0].id : "",
        perusahaan: {
          id: this.props.dataReport
            ? this.props.dataReport.content[0].perusahaan.id
            : "",
        },
      };
      this.props
        .editData({
          dispatch: "",
          title: menu,
          path: pathAPI,
          body: editDataInput,
        })
        .then(() => {
          this.setState({
            isLoadingButton: false,
          });
        });
    } else {
      this.props
        .postData({
          dispatch: "",
          title: menu,
          path: pathAPI,
          body: newDataInput,
        })
        .then(() => {
          this.setState({
            isLoadingButton: false,
          });
        });
    }
  };

  render() {
    const { isLoadingButton } = this.state;
    const { menu, pathAPI } = this.props;
    const user = JSON.parse(localStorage.getItem("user"));
    const isAdmin = user.role < 4;

    return (
      <>
        <HeaderCompReport />
        <LoadingTop />
        <Form>
          <div className="container mt-3">
            <div className="card container shadow-sm border-0">
              <div className="row" style={{ minHeight: "20rem" }}>
                <div className="col-2 py-3 border-right">
                  <MenuMonth pathUrl={pathAPI} />
                </div>
                <div className="col-10 py-3">
                  <span>
                    <MenuTopReport>
                      {menu === "Laba/Rugi" ? (
                        <Laba
                          postData={this.postData}
                          isLoadingButton={isLoadingButton}
                        />
                      ) : menu === "Neraca" ? (
                        <Neraca
                          postData={this.postData}
                          isLoadingButton={isLoadingButton}
                        />
                      ) : menu === "Arus Kas" ? (
                        <Arus
                          postData={this.postData}
                          isLoadingButton={isLoadingButton}
                        />
                      ) : menu === "LPE" ? (
                        <Lpe
                          postData={this.postData}
                          isLoadingButton={isLoadingButton}
                        />
                      ) : isAdmin ? (
                        <DokumenReadonly />
                      ) : (
                        <Dokumen />
                      )}
                    </MenuTopReport>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </Form>
      </>
    );
  }
}

const reduxState = (state) => {
  return {
    dataReport: state.reportReducer.dataReport,
    menu: state.reportReducer.menu,
    main: state.main,
    dataBulan: state.reportReducer.dataBulan,
    pathAPI: state.reportReducer.pathAPI,
  };
};

const reduxDispatch = (dispatch) => ({
  editData: (data) => dispatch(editDataAction(data)),
  postData: (data) => dispatch(postDataAction(data)),
});

export default connect(reduxState, reduxDispatch)(Report);
